import AdminUsersSearchResult from "./adminUsersDbSearchResult";

export const AdminUsers = () => {


    return (
        <>
            <AdminUsersSearchResult />
        </>
    )    
}

export default AdminUsers;